import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import logo from './softdof_logo.svg';
import { useNavigate } from 'react-router-dom'; // Add this
import Config from '../config.json';

const pages = [];
const settings = ['Logout'];

function ResponsiveAppBar({onLogoutClick, setSelectedTab, selectedTab}) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate(); 

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const onRegisterClick = () => {
    navigate('/register', { replace: true });
  }

  const onVerifyClick = () => {
    navigate('/verify', { replace: true });
  }



  const onLoginClick = () => {
    navigate('/', { replace: true });
  }

  return (<AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
          {/* <img sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} src={logo} alt='SS' width={'48px'} class="img-fluid" style={{filter:'invert(100%) sepia(0%) saturate(0%) hue-rotate(130deg) brightness(99%) contrast(103%)'}} /> */}
  
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={() => {handleCloseNavMenu(); setSelectedTab(page.toLowerCase())}}>
                  <Typography fontWeight={ page.toLowerCase() === selectedTab.toLowerCase() ? 'bolder' : 'normal' } textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
          <><img sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} src={logo} alt='SS' width={'48px'} class="img-fluid" style={{filter:'invert(100%) sepia(0%) saturate(0%) hue-rotate(130deg) brightness(99%) contrast(103%)'}} />&nbsp;&nbsp;</>
           
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => {handleCloseNavMenu(); setSelectedTab(page.toLowerCase())}}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                <Typography fontWeight={ page.toLowerCase() === selectedTab.toLowerCase() ? 'bolder' : 'normal' } textAlign="center">{page}</Typography>
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="SoftDOF SUpercomputing" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={()=>{handleCloseUserMenu(); onLogoutClick();} }>
                  <Typography textAlign="center" >{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Button
                key={"Register"}
                onClick={onRegisterClick}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {"Register"}
          </Button>
          <Button
                key={"Verify"}
                onClick={onVerifyClick}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {"Verify"}
          </Button>
          <Button
                key={"Login"}
                onClick={onLoginClick}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {"Login"}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;